/**
 * @desc 批量生成调拨单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.allocationPlan.batchCreate.Params, options?: any) {
  return updateResponse(
    http(URL + `/allocationPlan/batchCreate`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
